import { Modal } from "antd"

const Migration = () => {

    return (
        <Modal
            open={true}
            footer={null}
            centered
            closeIcon={false}
        >
            <p className="text-white ">
                {/* ⚠️ Data Migration in Progress / 新链数据同步中<br />
                ┌─────────────────────────────────────────┐<br />
                │  🔄  Data migration is in progress       │<br />
                │     数据迁移进行中                        │<br />
                │                                          │<br />
                │  To provide more stable services, we     │<br />
                │  are performing a data migration.         │<br />
                │  为提供更稳定的服务，我们正在              │<br />
                │  进行数据迁移。                           │<br />
                │                                          │<br />
                │  📦  Impact: features unavailable   │<br />
                │     影响范围：功能暂不可使用             │<br />
                │  ✅  Data is safe & fully preserved      │<br />
                │     数据保障：完整保留，不会丢失           │<br />
                │                                          │<br />
                │  The system will auto-restore when       │<br />
                │  migration completes. No action needed.   │<br />
                │  迁移完成后系统将自动恢复，               │<br />
                │  无需您进行任何操作。                     │<br />
                │                                          │<br />
                │  Sorry for the inconvenience 🙏          │<br />
                │  给您带来不便，敬请谅解                   │<br />
                └─────────────────────────────────────────┘<br /> */}
                关于NFX生态公链数据平移暂停的通知<br />
                <br />
                各位NFX生态用户：<br />
                <br />
                为进一步优化NFX生态架构，提升生态系统安全稳定性，保障项目长期稳健、可持续发展，经项目团队统筹规划，现正式启动公链平移升级工作。<br />
                <br />
                本次将进行Fibonacci公链向INTL公链数据整体数据平移迁移，平移周期为2026年9月14日 14:30 至 2026年9月28日 14:00。为保障平移工作顺利推进、数据完整无误，平移期间将临时暂停NFX链上操作服务，望各位用户知悉。<br />
                <br />
                特此郑重说明，本次公链数据平移升级仅影响跨链相关功能和NFX链上操作服务，完全不影响所有用户的NFX正常收益和机制、收益结算规则保持不变，用户资产及生态权益全程安全可控。<br />
                <br />
                本次升级是NFX生态迭代升级的重要举措，将为生态后续发展筑牢底层基础。后续项目团队将实时同步迁移进度，如有相关疑问，可咨询官方客服。感谢所有用户的理解、支持与陪伴！<br />
                ★特别提醒:<br />
                1，请保管好原有助记词/私钥；<br />
                2，届时请关注线上培训指导，提供在线操作服务支持；<br />
                NFX生态项目团队<br />
            </p>
        </Modal>
    )
}

export default Migration